import {Component, NgZone, OnInit} from '@angular/core';
import {Account} from '../../shared/models/account';
import {AngularFireAuth} from '@angular/fire/auth';
import {SessionService} from '../../core/service/session.service';
import {AngularFireFunctions} from '@angular/fire/functions';
import {MessageService} from '../../core/service/message.service';
import {Message} from '../../shared/models/message';
import {MainWindowComponent} from '../../core/main-window/main-window.component';
import {ResizeService} from '../../core/service/resize.service';

@Component({
  selector: 'app-password-update',
  templateUrl: './password-update.component.html',
  styleUrls: ['./password-update.component.scss'],
})
export class PasswordUpdateComponent implements OnInit {
  show = false;
  public account = new Account();
  pass: any = {password: '', confirmpassword: ''};
  password2: any;
  menuShow = false;
  showLoading = false;
  alertMessage: string
    = 'パスワードを更新しています。\r\n'
    + 'このページから離れないでください。';
  // 追加
  constructor(private auth: AngularFireAuth,
              private sessionService: SessionService,
              private fns: AngularFireFunctions,
              private messageService: MessageService,
  ) {}

  /**
   *
   */
  ngOnInit(): void {
  }

  /**
   *
   * @param e
   */
  submitLogin(e: Event): void {
    e.preventDefault();

    const subscription = this.auth.user.subscribe(user => {
      subscription.unsubscribe();
      // loading screen.
      this.showLoading = true;
      user?.updatePassword(this.pass.password)
        .then(() => {
          this.fns.httpsCallable('authentication-authentication-setClaimsPasswordUpdated')('')
            .subscribe(() => {
              const message = new Message();
              message.type = 'info';
              message.message = 'パスワードの更新に成功しました。';
              this.messageService.messageSubject.next(message);
              this.showLoading = false;
              this.sessionService.logout();
            }, (err: any) => {
              console.error(err);
              const message = new Message();
              message.type = 'error';
              message.message = 'パスワードの更新に失敗しました。' + err;
              this.messageService.messageSubject.next(message);
              this.showLoading = false;
            });
        }).catch(err => {
          console.error(err);
          const message = new Message();
          message.type = 'error';
          message.message = 'パスワードの更新に失敗しました。' + err;
          this.messageService.messageSubject.next(message);
          this.showLoading = false;
        });
    });
  }
}
